import { render } from "./ProductInfoV2.vue?vue&type=template&id=1769b3df&scoped=true"
import script from "./ProductInfoV2.vue?vue&type=script&lang=js"
export * from "./ProductInfoV2.vue?vue&type=script&lang=js"

import "./ProductInfoV2.vue?vue&type=style&index=0&id=1769b3df&scoped=true&lang=css"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1769b3df"]])

export default __exports__